import React, { useState, useEffect } from 'react';
import SimpleMap from './SimpleMap';
import DataPanel from './datapanel';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import WorkspaceButton from "../../pages/workspacebtn/workspacebtn"
import { FaRegUserCircle } from "react-icons/fa";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md"
import IndicatorsList from "../Indicator/Indicator";
import { removeIndicator, setWorkspaceLoaded, startNewWorkspace, addMapIndicator } from "store/workspaceSlice";
import { BASE_URL, CACHED_BASE_URL } from '../../../commonConfig/ApiConfig'
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useAutoLoadDefaultWorkspace } from 'components/authentication/signup-login/useAutoLoadDefaultWorkspace';
import '../../../assets/scss/cmn.scss'
import CustomToast from 'components/toast/customToast';
import { addIndicator } from "store/workspaceSlice";
import Cmn_Workspace from 'components/cmn_workspace/cmn_workspace';
import SectorHierarchyCards from './SectorHierarchyCards';
import BarChart from '../charts_visualization/bar_chart';
import PieChart from '../charts_visualization/pie_chart';
import { useAuth } from 'components/authentication/signup-login/AuthContext';
import SaveWorkspaceModal from 'components/authentication/signup-login/SaveWorkspaceModal';
import AuthModalHandler from 'components/authentication/signup-login/AuthModalHandler';
import { clearIndicators } from "store/checkboxindicatorSlice";
import { MdInfoOutline } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useBreakpoints } from 'hooks/useBreakpoints';
// import { removeIndicator } from "store/workspaceSlice";
const MapPage = () => {
  const [geoJsonData, setGeoJsonData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedFeatureStack, setSelectedFeatureStack] = useState([]);
  const [currentLevel, setCurrentLevel] = useState('national');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { breakpoints } = useBreakpoints();
      //=========== Mobile View =============
      const isMobile = breakpoints.down('md');

  // Authentication and workspace states
  const { isAuthenticated, login } = useAuth(); const [showSaveModal, setShowSaveModal] = useState(false);
  const isWorkspaceLoaded = useSelector(state => state.workspace.isWorkspaceLoaded);
  const loadedWorkspaceName = useSelector(state => state.workspace.loadedWorkspaceName);
  const hasUnsavedChanges = useSelector(state => state.workspace.hasUnsavedChanges);

  const [indicators, setIndicators] = useState([]);
  const [filteredIndicators, setFilteredIndicators] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [indicatorError, setIndicatorError] = useState(null);
  const [indicatorLoading, setIndicatorLoading] = useState(true);
  const [panelData, setPanelData] = useState({});
  const [showWorkspace, setShowWorkspace] = useState(true);
  const [filterMetaData, setMetaData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [indicatorFilterData, setFilterIndicatorData] = useState([]);
  const [localToastMessage, setLocalToastMessage] = useState('');
  const [showLocalToast, setShowLocalToast] = useState(false);
  const location = useLocation();

  // Sector and chart states
  const [sectorMetaData, setSectorMetaData] = useState([]);
  const [showIndicators, setShowIndicators] = useState(false);
  const [selectedSectorPath, setSelectedSectorPath] = useState({
    sector: null,
    subSector: null,
    subSubSector: null,
  });
  const [showChartsView, setShowChartsView] = useState(false);
  const [showPieChartsView, setShowPieChartsView] = useState(false);
  const [indicatorsForChart, setIndicatorsForChart] = useState([]);
  const [indicatorsForChartpie, setIndicatorsForChartpie] = useState([]);
  const [dataChecked, setDataChecked] = useState([]);

  // Redux selectors
  const selectedIndicatorsByCheckbox = useSelector(
    (state) => state.checkboxSlice?.items
  );
  const selectedMapFeatures = useSelector(state => state.workspace.selectedMapFeatures);
  const selectedIndicators = useSelector(state => state.workspace.selectedIndicators);

  // Chart payload preparations
  const formattedIndicators = indicatorsForChart.map((ind) => ({
    i_code: ind.indicator_code || "",
    si_code: ind.sub_indicator_code || "",
  }));

  const locationlgdforchart = panelData?.lgd_code;
  const locationgeolevelforchart = panelData?.geo_level_code;
  const locationsforchart = {
    code: locationlgdforchart,
    geo_level_code: locationgeolevelforchart,
  };

  const payload = {
    lgd_codes: [locationsforchart],
    lgd_code: locationlgdforchart,
    geo_level_code: locationgeolevelforchart,
    indicators: formattedIndicators,
    selected_Location: [{ "value": panelData.lgd_code, "label": panelData.name, "geo_level": panelData?.geo_level_code }],
    barindicator_info: selectedIndicatorsByCheckbox
    // indicatorsForChart.reduce((acc, ind) => {
    //   acc[ind.indicator_code] = ind;
    //   return acc;
    // }, {})
  };

  const pie_payload = {
    lgd_codes: [locationsforchart],
    indicators: [indicatorsForChartpie.indicator_code],
  };

  // Load default workspace hook
  useAutoLoadDefaultWorkspace();

  const visualize = (selectedIndicators) => {
    navigate('/mapconfig', { state: { selectedIndicators, selectedMapFeatures } });
  };

  const fetchGeoJson = async (level, params = {}) => {
    setLoading(true);
    setError(null);
    setIndicatorLoading(true);

    let url = `${CACHED_BASE_URL}locations`;
    if (level === 'national') {
      url += `/1000?geo_level=1`;
    } else if (level === 'state' && params.id && params.level) {
      url += `/${params.id}?geo_level=${params.level}`;
    } else if (level === 'district' && params.id && params.level) {
      url += `/${params.id}?geo_level=${params.level}`;
    } else if (level === 'ulb' && params.id && params.level) {
      url += `/${params.id}?geo_level=${params.level}`;
    }
      const localPayload = {
    lgd_code: params.id ?? 1000,
    geo_level_code: params.level ?? 1
  };

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      setPanelData(data.locations)
      dispatch(clearIndicators());
      setIndicators(data.indicators);
      setFilteredIndicators(data.indicators);
      setMetaData(data.filter_metadata);
      // Check if GeoJSON is available in the response else call API to get GeoJSON
      const hasGeoJson =
      data.locations.geojson &&
      Object.keys(data.locations.geojson).length > 0;


    if (hasGeoJson) {
      setGeoJsonData(data.locations.geojson);
    } else {
                const geo = await axios.get(`${CACHED_BASE_URL}locations/s-geojson`, {
  params: {
    lgd_code: localPayload.lgd_code,
    geo_level_code: localPayload.geo_level_code,
  }});
      setGeoJsonData(geo.data.geojson);
    }
      setSectorMetaData(data.sector_metadata || []);
    } catch (err) {
      setError(err?.message || 'Error fetching GeoJSON');
      setIndicatorError(error?.message);
    } finally {
      setLoading(false);
      setIndicatorLoading(false);
    }
  };
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  // Save workspace functionality
  const [modalMode, setModalMode] = useState('save'); // Add this state

  const handleSaveClick = (mode = 'save') => {
    if (!isAuthenticated) {
      setModalMode(mode);
      setPendingAction('save');
      setShowAuthModal(true);
      return;
    }

    if (selectedIndicators.length === 0) {
      alert('Please select at least one indicator');
      return;
    }

    setModalMode(mode);
    setShowSaveModal(true);
  };
  const handleLoginSuccess = (response) => {

    // Extract user data and token from response
    const loginData = response.data || response;
    let userData = null;
    let token = null;

    if (loginData && loginData.user) {
      userData = loginData.user;
      token = loginData.token;
    } else {
      userData = {
        name: response.name || response.user?.name || 'User',
        email: response.email || response.user?.email || 'user@example.com'
      };
      token = response.token || response.access_token;
    }

    // Update global auth context
    login(userData, token);

    setShowAuthModal(false);

    if (pendingAction === 'save') {
      if (selectedIndicators.length === 0) {
        return;
      }
      setShowSaveModal(true);
    }

    setPendingAction(null);
  };

  const handleSaveSuccess = (workspaceData) => {
    alert(`Workspace "${workspaceData.name}" saved successfully!`);

    // Always load the saved workspace as current (for both new saves and save as)
    if (workspaceData.id && workspaceData.name) {
      // Add a small delay to ensure the workspace is properly created
      setTimeout(() => {
        // Dispatch action to load the workspace
        dispatch(setWorkspaceLoaded({
          id: workspaceData.id,
          name: workspaceData.name,
          workspace: workspaceData
        }));
      }, 100);
    }

    setShowSaveModal(false);
  };

  const handleNewWorkspace = () => {
    // Clear all indicators and locations and reset to "My Workspace" state
    dispatch(startNewWorkspace());
  };

  const onFilterApplyHandler = (filteredData) => {
    setIsFilterApplied(true);
    setFilterIndicatorData(Array.isArray(filteredData) ? filteredData : []);
  };

  const baseData = isFilterApplied
    ? (Array.isArray(indicatorFilterData) ? indicatorFilterData : [])
    : (Array.isArray(indicators) ? indicators : []);

  const search = searchTerm?.trim().toLowerCase() || "";

  const onFeatureSelect = (geoJsonData) => {
    const nextLevel =
      currentLevel === 'national'
        ? 'state'
        : currentLevel === 'state'
          ? 'district'
          : currentLevel === 'district'
            ? 'ulb'
            : null;

    if (!nextLevel) return;

    const params = {};

    if (nextLevel === 'state') {
      params.id = geoJsonData.properties?.code || geoJsonData?.code;
      params.level = geoJsonData?.geo_level || geoJsonData.properties?.geo_level_code;
    } else if (nextLevel === 'district') {
      params.id = geoJsonData.properties?.code || geoJsonData?.code;
      params.level = geoJsonData?.geo_level || geoJsonData.properties?.geo_level_code;
    } else if (nextLevel === 'ulb') {
      params.id = geoJsonData?.code || geoJsonData.properties?.code;
      params.level = geoJsonData?.geo_level || geoJsonData.properties?.geo_level_code;
    }

    setSelectedFeatureStack([...selectedFeatureStack, geoJsonData]);
    setCurrentLevel(nextLevel);
    fetchGeoJson(nextLevel, params);
  };

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredIndicators(indicators);
    } else {
      const lower = searchTerm.toLowerCase();
      const filtered = indicators.filter(ind =>
        ind.indicator_name?.toLowerCase().includes(lower) ||
        ind.dataset_name?.toLowerCase().includes(lower) ||
        ind.agency_name?.toLowerCase().includes(lower)
      );
      setFilteredIndicators(filtered);
    }
  }, [searchTerm, indicators]);

  const handleIndicatorSelect = (indicator) => {
    toast(<CustomToast message={`${indicator.indicator_name} added to <b>workspace</b>`} type="success" />, { position: isMobile? "middle-center" : "top-right" });
    dispatch(addIndicator(indicator));

    // Also add current location to workspace if we have location data
    if (panelData && panelData.lgd_code && panelData.geo_level_code && !(panelData.lgd_code === 1000 && panelData.geo_level_code === 1)) {
      const locationData = {
        id: panelData.lgd_code,
        geo_level_code: panelData.geo_level_code,
        name: panelData.name,
        properties: {
          name: panelData.name,
          code: panelData.lgd_code,
          geo_level_code: panelData.geo_level_code
        }
      };

      // Check if location already exists in workspace (uniqueness based on lgd_code and geo_level_code)
      const existingLocation = selectedMapFeatures.find(
        loc => loc.id === locationData.id && loc.geo_level_code === locationData.geo_level_code
      );

      if (!existingLocation) {
        dispatch(addMapIndicator(locationData));
        toast(<CustomToast message={`${panelData.name} added to <b>workspace</b>`} type="loaction" />, { position: isMobile? "middle-center" : "top-right" });
      }
    }
  };

  // Handle incoming feature from explore page
  useEffect(() => {
    const incomingFeature = location.state?.selectedStateFeature;

    if (incomingFeature) {
      const params = {
        id: incomingFeature?.properties?.code || incomingFeature?.code,
        level: incomingFeature?.geo_level || incomingFeature?.properties?.geo_level_code
      };
      setSelectedFeatureStack([incomingFeature]);
      setCurrentLevel('state');
      fetchGeoJson('state', params);
    } else {
      fetchGeoJson('national');
    }
  }, []);

  const onBack = ({ code, geo_level_code }) => {
    const params = { id: code, level: geo_level_code };

    if (geo_level_code === 1) {
      setCurrentLevel("national");
      fetchGeoJson("national");
    } else if (geo_level_code === 2) {
      setCurrentLevel("state");
      fetchGeoJson("state", params);
    } else if (geo_level_code === 3) {
      setCurrentLevel("district");
      fetchGeoJson("district", params);
    } else if (geo_level_code === 4) {
      setCurrentLevel("ulb");
      fetchGeoJson("ulb", params);
    }

    setSelectedFeatureStack([]);
    setShowChartsView(false);
    setShowPieChartsView(false);
    setShowIndicators(false);
  };

  useEffect(() => {
    if (showIndicators) {
      setDataChecked(selectedIndicatorsByCheckbox);
    }
  }, [showIndicators, selectedIndicatorsByCheckbox]);

  const selectedFeature =
    panelData || selectedFeatureStack[selectedFeatureStack.length - 1] || {};

  if (loading) return <div style={{ padding: '24px' }}>Loading map data...</div>;
  if (error) return <div style={{ padding: '24px', color: 'red' }}>Error: {error}</div>;

  return (
    <>
      <WorkspaceButton
        showWorkspace={showWorkspace}
        setShowWorkspace={setShowWorkspace}
      />
      <div className="d-flex flex-grow-1" style={{ height: 'calc(100vh - 60px)' }}>
        {/* Data Panel */}
        <div
          className={`bg-white p-3 overflow-auto`}
          style={{
            width: showIndicators ? (!showWorkspace ? 'calc(100% - 420px)' : '100%') : '60%',
          }}
        >
          {/* Main Data Panel */}
          <DataPanel
            feature={selectedFeature}
            level={currentLevel}
            onBack={onBack}
            canGoBack={selectedFeatureStack.length > 0}
          />

          {/* Conditional Panel: Sector Hierarchy or Indicators */}
          {!showIndicators && <SectorHierarchyCards
            sectorData={sectorMetaData}
            onSectorSelect={(sector, subSector, subSubSector) =>
              setSelectedSectorPath({ sector, subSector, subSubSector })
            }
            selectedCategory={selectedCategory}
            onCategorySelect={(category) => {
              setSelectedCategory(category);
              setSelectedSectorPath({
                sector: null,
                subSector: null,
                subSubSector: null,
              });
            }}
            selectedSector={selectedSectorPath.sector}
            selectedSubSector={selectedSectorPath.subSector}
            selectedSubSubSector={selectedSectorPath.subSubSector}
          />}

          <div>
            <div className="row">
              <div className="col">
                {(selectedSectorPath.sector || selectedSectorPath.subSector || selectedSectorPath.subSubSector) && showIndicators && !showChartsView && !showPieChartsView && (
                  <div className=" px-4">
                    <div className="d-flex flex-wrap gap-4">
                      {selectedSectorPath.sector && (
                        <div className="d-flex flex-column me-5 mb-0 f-16">
                          <span className="text-md-start text-dark">Sector:</span>
                          <span className="text-md-start text-secondary">{selectedSectorPath.sector.name}</span>
                        </div>
                      )}

                      {selectedSectorPath.subSector && (
                        <div className="d-flex flex-column me-5 mb-0 f-16">
                          <span className="text-md-start text-dark">Sub Sector:</span>
                          <span className="text-md-start text-secondary">{selectedSectorPath.subSector.name}</span>
                        </div>
                      )}

                      {selectedSectorPath.subSubSector && (
                        <div className="d-flex flex-column me-5 mb-0 f-16">
                          <span className="text-md-start text-dark">Sub Sub Sector:</span>
                          <span className="text-md-start text-secondary">{selectedSectorPath.subSubSector.name}</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="col">
                {/* Toggle Button */}
                <div className="mb-2 text-end">
                  {!showChartsView && !showPieChartsView ? (
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => {
                        setShowIndicators((prev) => {
                          const next = !prev;
                          if (!next) {
                            // Clear selected sector path when hiding indicators
                            // setSelectedSectorPath({
                            //   sector: null,
                            //   subSector: null,
                            //   subSubSector: null,
                            // });
                            // setSelectedCategory('All'); // Clear selected category
                          }
                          return next;
                        });
                      }}
                    >
                      {showIndicators ? 'Hide Indicators' : 'Show Indicators'}
                    </Button>
                  ) : (
                    <Button variant="outline-primary" size="sm" onClick={() => {
                      setShowChartsView(false);
                      setShowPieChartsView(false);
                    }}>
                      Show Indicators
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>

          {showIndicators && !showChartsView && !showPieChartsView && (
            <IndicatorsList
              indicatorData={indicators}
              filterMetaData={filterMetaData}
              onIndicatorSelect={handleIndicatorSelect}
              selectedIndicators={selectedIndicators}
              onFilterApply={onFilterApplyHandler}
              sectorFilter={selectedSectorPath}
              onShowCharts={(selectedIndicatorsForChart) => {
                setShowChartsView(true);
                setShowPieChartsView(false);
                setIndicatorsForChart(selectedIndicatorsForChart);
              }}
              onShowPieCharts={(selectedIndicatorsForpieChart) => {
                setShowChartsView(false);
                setShowPieChartsView(true);
                setIndicatorsForChartpie(selectedIndicatorsForpieChart);
              }}
              selectedIndicatorsByCheckbox={selectedIndicatorsByCheckbox}
              dataChecked={dataChecked}
            />
          )}

          {showIndicators && showChartsView && !showPieChartsView && (
            <div>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5>Bar Chart</h5>
              </div>
              <BarChart chart_location_payload={payload} indicatorsForChart={selectedIndicatorsByCheckbox} />
            </div>
          )}

          {showIndicators && showPieChartsView && !showChartsView && (
            <div>
              {/* <div className="d-flex justify-content-between align-items-center mb-2">
                 <h5>{indicatorsForChartpie.indicator_name}</h5> 
              </div> */}
              <PieChart chart_location_payload={pie_payload} />
            </div>
          )}

          {/* Workspace Sidebar */}
          {!showWorkspace && (
            <div
              className="position-fixed mb-5 end-0 bg-white workspace-scroll shadow"
              style={{
                top: '68px',
                width: '420px',
                height: '100vh',
                zIndex: 1050,
                overflowY: 'scroll',
                padding: '0',
                borderLeft: '1px solid #ddd',
                msOverflowStyle: 'none',
                scrollbarWidth: 'none',
              }}
            >
              <div className="h-100 border-0">
                <div className="card-header ui-card-header d-flex justify-content-between align-items-center border-0">
                  <h5 className="mb-0">
                    <FaRegUserCircle /> &nbsp;
                    {isWorkspaceLoaded ? loadedWorkspaceName : 'My Workspace'}
                    {hasUnsavedChanges && <span className="text-warning ms-2">*</span>}&nbsp;
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="filter-tooltip">
                          <p>Click save to access your work later.</p>
                        </Tooltip>
                      }
                    >
                      <span>
                        <MdInfoOutline style={{ cursor: "pointer", color: "#000000" }} />
                      </span>
                    </OverlayTrigger>
                  </h5>
                  <button
                    className="btn btn-sm btn-outline-dark"
                    onClick={() => setShowWorkspace(true)}
                  >
                    <MdOutlineKeyboardDoubleArrowRight />
                  </button>
                </div>
                <div className="card-body pt-3 p-2">
                  <div className="row">
                    <div className="col-12">
                      <div className="d-flex justify-content-end">
                        <div className="p-1">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => handleSaveClick(isWorkspaceLoaded ? 'update' : 'save')}
                          >
                            <i className={`bi ${isWorkspaceLoaded ? 'bi-arrow-repeat' : 'bi-save'} me-1`}></i>
                            {isWorkspaceLoaded ? 'Update' : 'Save'}
                          </Button>
                        </div>
                        <div className="p-1">
                          <Button variant="outline-primary" className="btn-sm f-14" onClick={() => handleSaveClick('saveAs')}>
                            Save As
                          </Button>
                        </div>
                        <div className="p-1">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={handleNewWorkspace}
                          >
                            <i className="bi bi-plus-circle me-1"></i> New
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Cmn_Workspace visualize={(inds) => { visualize(inds) }}
                    showWorkspace={showWorkspace}
                    setShowWorkspace={setShowWorkspace} />
                </div>

              </div>
            </div>
          )}
        </div>

        {/* Map Panel (only when not showing indicators) */}
        {!showIndicators && (
          <div
            className="bg-white d-none d-md-block overflow-hidden"
            style={{
              width: '40%',
              transition: 'width 0.3s ease',
            }}
          >

            <SimpleMap
              geoJsonData={geoJsonData}
              selectedFeature={selectedFeature}
              level={currentLevel}
              onFeatureSelect={onFeatureSelect}
            />
            <div style={{ backgroundColor: '#f8f9fa', padding: '8px 8px' }}>
              <p className="text-center small mb-0" style={{ color: '#6c757d', margin: '0' }}>
                Disclaimer: State and district boundaries are sourced from the Survey of India.
                City and Urban Local Government (ULG) geo-coordinates are sourced from the City Finance platform.
                If a ULG’s geo-coordinates are not displayed, it indicates their unavailability on the source platform.
                For some Tier-1 and Tier-2 cities, coordinates—if unavailable—are derived from prominent local landmarks where necessary.</p>
            </div>
          </div>
        )}

        {/* Save Workspace Modal */}
        <SaveWorkspaceModal
          show={showSaveModal}
          handleClose={() => setShowSaveModal(false)}
          onSave={handleSaveSuccess}
          selectedIndicators={selectedIndicators}
          selectedLocations={selectedMapFeatures}
          allMapFeatures={selectedMapFeatures}
          mode={modalMode}
        />
        <AuthModalHandler
          show={showAuthModal}
          handleClose={() => {
            setShowAuthModal(false);
            setPendingAction(null);
          }}
          initialMode="login"
          onLoginSuccess={handleLoginSuccess}
        />
      </div>
    </>
  );
};

export default MapPage;